import React from "react";
import { Container, Box, Typography, Avatar } from "@mui/material";

const About: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          gap: { xs: 4, md: 6 },
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 3 }}>
            Hello!
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            My name is Shashi Sharma. I'm a computer science graduate and a
            professional Flutter developer since 2019. I build cross-platform
            mobile apps, backend integrations and developer tools — and I enjoy
            turning ideas into production-ready products quickly.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            I started with Flutter when it was still in beta, and since then
            I've shipped apps spanning diverse domains — productivity, finance,
            weather, media libraries, and real-time chat. Along the way I've
            integrated Firebase, REST APIs, native platform channels, and
            third-party SDKs like Shorebird for over-the-air updates.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            Beyond mobile, I've always been curious about what happens under the
            hood. That curiosity pushed me into C and systems programming —
            memory management, dynamic linking, FFI — and eventually into areas
            like CPU architecture, Fourier analysis, and network protocols. I
            write about all of it here because I believe understanding
            fundamentals makes you a better engineer regardless of the language
            or platform you work in.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            My daily development environment is Neovim with a custom LSP setup
            — I wrote an entire article on it because it genuinely changed how I
            work. For editing and agentic work, I also use VS Code to pair with
            AI assistants and move quickly across larger codebases. I record
            unedited coding sessions on YouTube where I explore frameworks and
            libraries for the first time, raw and honest, no post-production.
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            How I learn: research the ecosystem, prototype a focused
            integration, then harden and document the result. This site is the
            documentation layer — every article started as something I needed to
            understand for myself. If it helps you too, that's even better.
          </Typography>
        </Box>

        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: 250,
              height: 250,
              borderRadius: "50%",
              background:
                "radial-gradient(circle, rgba(145, 189, 58, 0.3) 0%, rgba(145, 189, 58, 0) 70%)",
              filter: "blur(20px)",
              zIndex: 0,
            }}
          />
          <Avatar
            src="/assets/avatar.jpeg"
            alt="Shashi Sharma"
            sx={{
              width: 250,
              height: 250,
              position: "relative",
              zIndex: 1,
              border: "4px solid",
              borderColor: "primary.main",
              boxShadow: "0 8px 32px rgba(145, 189, 58, 0.2)",
            }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default About;
